import BaseService from '../BaseService';
import api from '../../services/api';

class OperadorasSaudeService extends BaseService {
    constructor() {
        super('/operadoras-saude/');
    }

    listarTodas(apenasAtivas = true) {
        const params = { sem_paginacao: true };

        if (apenasAtivas) {
            params.status = true;
        }

        return api.get('/operadoras-saude/', { params });
    }
}

const operadorasSaudeService = new OperadorasSaudeService();

export default operadorasSaudeService;
